// extracted by mini-css-extract-plugin
export default {"container":"up-z","brandName":"vp-z","productName":"wp-z","productNamePdpEnhancements":"xp-z","breakLongProductName":"yp-z"};